// §34.12 / §9.1 — Weather's registration stub.
//
// **Manifest and thunk only** (D-511); the chunk is `lazy.Weather-<hash>.js`.
//
// `requiresAuth: true` makes it **the only gated app in this wave** (D-497), and the mechanism matters:
// registration cannot hide it, because `buildKernel()` runs before identity is known (§24.11, D-200).
// `kernel.apps.visible()` is what keeps it off a guest's desktop, launcher and Store — and it does so
// for the honest reason that a guest reaches no server at all (D-024), so there is no forecast for one.
import type { InProcessApp, WeatherShellAccess } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';
import { COPY } from '@/copy';
import { WEATHER_WINDOW } from '@/config';

export function createWeatherApp(access: WeatherShellAccess): InProcessApp {
  return createLazyApp({
    app: {
      id: 'weather',
      name: COPY.weather.title,
      category: 'Utilities',
      // Hue from §14's ladder: sky blue, the one colour this app could not be anything else.
      icon: { glyph: 'cloud-sun', hue: 205 },
      keywords: ['forecast', 'temperature', 'rain', 'weather', 'conditions'],
      // §34.12 / D-497 — the wave's only gated app. §24.11's `visible()` enforces it.
      requiresAuth: true,
      window: { ...WEATHER_WINDOW, multiWindow: false },
    },
    load: () => import('./Weather'),
    props: { access },
  });
}
